
import React, { Component } from 'react';
import ApplyCSS from '../../../../components/ApplyCSS';

import commonUtil from '../../../../utils/commonUtil';

const pageName = 'contract';
const channel = commonUtil.getChannel();


class ContractPageForDownloadPDF extends Component {
  render() {
    const { lables, contractData, userAllData } = this.props; // eslint-disable-line no-shadow
    let currentDate = new Date();
    const month = currentDate.getMonth() + 1;
    currentDate = currentDate.getDate() + '/' + month + '/' + currentDate.getFullYear();
    return (
      <div className="toPrint contract">
        <ApplyCSS pageName={pageName} />
        <div className="p-t-20">
          <div><b>Festejados:&nbsp;</b>{userAllData && userAllData.celebrityInfo && userAllData.celebrityInfo.length > 0 ?
            userAllData.celebrityInfo.map((data) => {
              const email = data && data.email ? '<' + data.email + '>,' : null;
              return (
                <span>{data.firstName} {data.lastName} {email}&nbsp;</span>);
            })
            :
            null}</div>
          <div><b>Fecha del evento:&nbsp;</b><span>{userAllData.eventDate}</span></div>
          <div><b>Tipo de evento:&nbsp;</b><span>{userAllData.eventType}</span></div>
          {/* <div><b>Numero de evento:</b><span /></div> */}
          <div><b>Fecha de creacion del evento:&nbsp;</b><span>{currentDate}</span></div>
          <div><b>Direcciones:&nbsp;</b>{userAllData && userAllData.addressesInfo && userAllData.addressesInfo.length > 0 ?
          userAllData.addressesInfo.map(data => (
            <span> {data && data.firstName ? data.firstName + ',' : ''}
              {data && data.middleName ? data.middleName + ', ' : ''}
              {data && data.lastName ? data.lastName + ', ' : ''}
              {data && data.maternalName ? data.maternalName + ', ' : ''}
              {data && data.address1 ? data.address1 + ', ' : ''}
              {data && data.exteriorNumber ? data.exteriorNumber + ', ' : ''}
              {data && data.interiorNumber ? data.interiorNumber + ', ' : ''}
              {data && data.building ? data.building + ', ' : ''}
              {data && data.city ? data.city + ', ' : ''}
              {data && data.neighbourhood ? data.neighbourhood + ', ' : ''}
              {data && data.delegationMunicipality ? data.delegationMunicipality + ', ' : ''}
              {data && data.postalCode ? data.postalCode + ', ' : ''}
              {data && data.country ? data.country + ', ' : ''}
              {data && data.state ? data.state : '' }.</span>
          ))
            :
            null}</div>
          {/* <div><b>Evento de empleado</b></div>
          <div><b>Tarjetas asignadas:</b><span /></div> */}
        </div>
        {channel === 'wap' ?
          <div className="innerWrap contractWrapper">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 col-xs-12 col-xs-offset-0" id="contract">
                <div className="ml-230">
               <h1 className="text-center m-b-30">{commonUtil.getLabel(lables.createEventStep4, 'createEventStep4.contract.title')}</h1>
             </div>
            <div className="ml-230">
              <p className="text-center">{commonUtil.getLabel(lables.createEventStep4, 'createEventStep4.contract.message')}</p>
            </div>
                <div className="container">
                  <p dangerouslySetInnerHTML={{ __html: contractData }} />
                </div>
              </div>
            </div>
          </div>
          :
          <div className="container pageAlignContract">
            <div className="ml-230">
              <h1 className="text-center m-b-30">{commonUtil.getLabel(lables.createEventStep4, 'createEventStep4.contract.title')}</h1>
            </div>
            <div className="ml-230">
              <p className="text-center">{commonUtil.getLabel(lables.createEventStep4, 'createEventStep4.contract.message')}</p>
            </div>
            <div className="">
              {/* <p className="ml-25">Contrato para la mesa de regalos de Liverpool</p> */}
              <p className="textAlignParagraphContract" dangerouslySetInnerHTML={{ __html: contractData }} />
            </div>
          </div>
        }
      </div>
    );
  }
}

export default ContractPageForDownloadPDF;
